module.exports = __webpack_public_path__ + "1.5.0-unryo/img/online-vault-5.ad95d193.svg";